<div class="container-fluid">
    <app-pagetitle title="Send Document" [subtitle]="'Upload and send documents for eSign'"
        [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

    <div #apiValidationMessage>
        <app-api-validation-message [error]="apiValidationError" [title]="apiValidationTitle" [dismissible]="true"
            (dismissed)="clearApiValidationMessage()">
        </app-api-validation-message>
    </div>

    <div class="row" [hidden]="isShowDoc || isUsedTemplateDoc">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div id="basic-pills-wizard" class="twitter-bs-wizard">
                        <ng-stepper #cdkStepper [linear]="true"
                            class="twitter-bs-wizard-nav nav nav-pills nav-justified">
                            <cdk-step [optional]="false" class="nav-item">
                                <ng-template cdkStepLabel>
                                    <a href="javascript: void(0);" class="nav-link active" data-toggle="tab">
                                        <span class="step-number">01</span>
                                        <span class="step-title">Upload</span>
                                    </a>
                                </ng-template>
                                <section *ngIf="currentStepIndex  === 0">
                                    <div class="tab-pane active" id="upload-details">
                                        <form [formGroup]="documentForm" (ngSubmit)="onSubmit()">
                                            <div class="row justify-content-center">
                                                <div class="col-lg-10 col-md-8 col-sm-10">
                                                    <div class="mb-3">
                                                        <label class="form-label" for="document-name">
                                                            Document Name <small class="text-danger">*</small>
                                                        </label>
                                                        <input type="text" class="form-control" id="document-name"
                                                            placeholder="e.g., Employment Agreement"
                                                            formControlName="name"
                                                            (keypress)="allowDocumentNameCharacters($event)"
                                                            (input)="filterDocumentNameInput($event, documentForm.get('name'))">
                                                        <div class="text-danger small mt-1"
                                                            *ngIf="documentForm.get('name')?.invalid && documentForm.get('name')?.touched">
                                                            <span
                                                                *ngIf="documentForm.get('name')?.errors?.['required']">
                                                                Document Name is required.
                                                            </span>
                                                            <span *ngIf="documentForm.get('name')?.errors?.['pattern']">
                                                                Document name can contain alphabets and spaces only.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row justify-content-center">
                                                <div class="col-lg-10 col-md-8 col-sm-10">
                                                    <div class="mb-3">
                                                        <label class="form-label" for="document-file">
                                                            Upload Document <small class="text-danger">*</small>
                                                        </label>

                                                        <input type="file" class="form-control" id="document-file"
                                                            (change)="onFileSelected($event)" accept="application/pdf">

                                                        <div class="form-text">
                                                            Allowed format: PDF. Maximum file size: 10 MB.
                                                        </div>
                                                        <div *ngIf="selectedFile" class="mt-1 text-muted small">
                                                            Selected file: <strong>{{ selectedFile.name }}</strong>
                                                        </div>
                                                        <div *ngIf="fileError" class="text-danger small mt-1">
                                                            {{ fileError }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row justify-content-center">
                                                <div class="col-lg-10 col-md-8 col-sm-10">
                                                    <div class="mb-3">
                                                        <label class="form-label" for="recipient-message">
                                                            Message for Recipients
                                                        </label>
                                                        <textarea class="form-control" id="recipient-message" rows="4"
                                                            formControlName="message" maxlength="250"></textarea>
                                                        <small class="text-muted">
                                                            {{ documentForm.get('message').value?.length || 0 }}/250
                                                            characters
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row justify-content-center">
                                                <div class="col-lg-10 col-md-8 col-sm-10">
                                                    <div class="mb-3">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox"
                                                                id="livePhoto" formControlName="livePhoto" />
                                                            <label class="form-check-label" for="livePhoto">
                                                                Enable Live Photo
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row justify-content-center">
                                                <div class="col-lg-10 col-md-8 col-sm-10">
                                                    <ul
                                                        class="pager wizard twitter-bs-wizard-pager-link d-flex justify-content-end">
                                                        <li class="next" aria-disabled="false">
                                                            <button class="btn btn-primary" type="button" cdkStepperNext
                                                                [disabled]="!documentForm.get('name')?.value || !selectedFile">
                                                                Next: Add Recipients →
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </section>
                            </cdk-step>

                            <cdk-step class="nav-item">
                                <ng-template cdkStepLabel>
                                    <a href="javascript:void(0)" class="nav-link" (click)="onStepClick($event)">
                                        <span class="step-number">02</span>
                                        <span class="step-title">Recipients</span>
                                    </a>
                                </ng-template>
                                <section *ngIf="currentStepIndex  === 1">
                                    <div class="tab-pane" id="recipients">
                                        <div>
                                            <form [formGroup]="documentForm" (ngSubmit)="onSubmit()">
                                                <div class="row justify-content-center">
                                                    <div class="col-lg-10 col-md-8 col-sm-10">
                                                        <div class="mb-3">
                                                            <label class="form-label" for="signing-order">
                                                                Signing Order
                                                            </label>
                                                            <select class="form-select" id="signing-order"
                                                                formControlName="signingOrder">
                                                                <option value="sequential">Sequential (in Order )
                                                                </option>
                                                                <!-- <option value="parallel">Parallel (all sign at same
                                                                    time)</option> -->
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div cdkDropList (cdkDropListDropped)="dropSigner($event)">
                                                    <div *ngFor="let recipient of signers.controls; let i = index"
                                                        cdkDrag class="row justify-content-center mb-2">
                                                        <div class="col-lg-10 col-md-8 col-sm-10">
                                                            <div class="bg-light-purple p-3 rounded">
                                                                <div class="row gx-2 align-items-center">
                                                                    <div class="col-1 d-flex justify-content-center">
                                                                        <div class="text-bold" cdkDragHandle
                                                                            title="Drag to reorder">
                                                                            ☰ {{ i + 1 }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-2">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="Full Name"
                                                                            [formControl]="recipient.get('name')"
                                                                            (keypress)="allowRecipientNameCharacters($event)"
                                                                            (input)="filterRecipientNameInput($event, recipient.get('name'))">

                                                                        <div class="text-danger small mt-1"
                                                                            *ngIf="recipient.get('name')?.invalid && recipient.get('name')?.touched">

                                                                            <span
                                                                                *ngIf="recipient.get('name')?.errors?.['required'] && recipient.get('name')?.value === ''">
                                                                                Name is required
                                                                            </span>
                                                                            <span
                                                                                *ngIf="recipient.get('name')?.touched && recipient.get('name')?.value && recipient.get('name')?.value.trim() === ''">
                                                                                Name cannot be empty or contain only spaces.
                                                                            </span>
                                                                            <span
                                                                                *ngIf="recipient.get('name')?.errors?.['pattern'] && recipient.get('name')?.value?.trim() !== ''">
                                                                                Name can contain alphabets and spaces
                                                                                only.
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-3">
                                                                        <input type="email" class="form-control"
                                                                            placeholder="Email"
                                                                            [formControl]="recipient.get('email')">

                                                                        <div class="text-danger small mt-1"
                                                                            *ngIf="recipient.get('email')?.touched && recipient.get('email')?.invalid">

                                                                            <span
                                                                                *ngIf="recipient.get('email')?.errors?.['required']">
                                                                                Email is required
                                                                            </span>

                                                                            <span
                                                                                *ngIf="recipient.get('email')?.errors?.['email']">
                                                                                Enter a valid email format
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-2">
                                                                        <input type="tel" class="form-control"
                                                                            maxlength="10" placeholder="Phone"
                                                                            [formControl]="recipient.get('phone')"
                                                                            inputmode="numeric" pattern="[0-9]*"
                                                                            (keypress)="allowDigitsOnly($event)"
                                                                            (input)="filterPhoneInput($event, recipient.get('phone'))">

                                                                        <div class="text-danger small mt-1"
                                                                            *ngIf="recipient.get('phone')?.invalid && recipient.get('phone')?.touched">

                                                                            <span
                                                                                *ngIf="recipient.get('phone')?.errors?.['required']">
                                                                                Phone number is required
                                                                            </span>

                                                                            <span
                                                                                *ngIf="recipient.get('phone')?.errors?.['pattern']">
                                                                                Enter a valid 10-digit number starting
                                                                                with 6-9
                                                                            </span>

                                                                        </div>
                                                                    </div>
                                                                    <div class="col-3">
                                                                        <select class="form-select"
                                                                            [formControl]="recipient.get('esignType')">

                                                                            <option value="" disabled>Select E-Sign Type
                                                                            </option>
                                                                            @for(type of esignTypes; track type;){
                                                                            <option [value]="type?.value">
                                                                                {{type?.label}}</option>
                                                                            }

                                                                        </select>
                                                                    </div>
                                                                    <div class="col-1 d-flex justify-content-center">
                                                                        <button class="btn btn-light" type="button"
                                                                            *ngIf="signers.length > 1"
                                                                            (click)="removeRecipient(i)">x</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div *ngIf="signers.length === 5" class="row justify-content-center">
                                                    <div class="col-lg-10 col-md-8 col-sm-10">
                                                        <div class="mb-3">
                                                            <div class="text-danger">You can add up to 5 recipients
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row justify-content-center">
                                                    <div class="col-lg-10 col-md-8 col-sm-10">
                                                        <div
                                                            class="pager wizard d-flex justify-content-between align-items-center">
                                                            <button class="btn btn-light" type="button"
                                                                (click)="addRecipient()"
                                                                [disabled]="signers.length >= 5">
                                                                + Add Another Recipient
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row justify-content-center">
                                                    <div class="col-lg-10 col-md-8 col-sm-10">
                                                        <ul
                                                            class="pager wizard twitter-bs-wizard-pager-link d-flex justify-content-between align-items-center">
                                                            <li class="previous">
                                                                <button class="btn btn-light" type="button"
                                                                    cdkStepperPrevious>
                                                                    ← Back
                                                                </button>
                                                            </li>

                                                            <li class="next">
                                                                <button class="btn btn-primary" type="button"
                                                                    (click)="goToNextStep(stepper)">
                                                                    Next: Add Recipients →
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </section>
                            </cdk-step>

                            <cdk-step [optional]="true" class="nav-item">
                                <ng-template cdkStepLabel>
                                    <a href="javascript: void(0);" class="nav-link" data-toggle="tab"
                                        (click)="onStepClick($event)">
                                        <span class="step-number">03</span>
                                        <span class="step-title">Review</span>
                                    </a>
                                </ng-template>
                                <section *ngIf="currentStepIndex  === 2">

                                    <div class="row justify-content-center mb-2">
                                        <div class="col-lg-10 col-md-8 col-sm-10">
                                            <div class="row gx-2 align-items-center">
                                                <div class="col-lg-10 col-md-8 col-sm-10">
                                                    <div class="mb-1">
                                                        <div class="fw-bold fs-5">Review & Send</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row justify-content-center mb-2">
                                        <div class="col-lg-10 col-md-8 col-sm-10">
                                            <div class="bg-light-purple p-3 rounded">
                                                <div class="row gx-3 align-items-center">
                                                    <div class="col-lg-10 col-md-8 col-sm-10">
                                                        <div class="mb-3">
                                                            <div class="form-label mb-1">Document Name</div>
                                                            <div class="fw-bold">{{documentForm.get('name')?.value}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row gx-3 align-items-center mb-2">
                                                    <div class="col-lg-10 col-md-8 col-sm-10">
                                                        <div class="mb-1">
                                                            <div class="form-label mb-1">Recipients
                                                                ({{recipientsList.length}})</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div *ngFor="let recipient of recipientsList; let i = index">
                                                    <div class="row gx-3 align-items-center mb-2 bg-white">
                                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center mb-1">
                                                                <div class="flex-grow-1">
                                                                    <div
                                                                        class="fw-bold d-flex align-items-center gap-2">
                                                                        {{ i + 1 }}. {{ recipient?.name }}
                                                                        <span
                                                                            *ngIf="documentService.getSigners[i]?.signatureDetail"
                                                                            class="text-success"
                                                                            title="Signature completed">
                                                                            ✔
                                                                        </span>
                                                                    </div>
                                                                    <div class="value">{{ recipient?.email }} • {{
                                                                        recipient?.phone }} • {{
                                                                        getEsignTypeVlaue(recipient?.esignType) }}</div>
                                                                </div>
                                                                <button class="btn btn-sm btn-outline-primary"
                                                                    (click)="signDoc(i)">Sign Doc</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row justify-content-center">
                                        <div class="col-lg-10 col-md-8 col-sm-10">
                                            <div class="row justify-content-center">
                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                    <button class="btn btn-light" type="button" cdkStepperPrevious
                                                        (click)="onBack()">
                                                        ← Back
                                                    </button>
                                                </div>

                                                <div class="col-lg-6 col-md-6 col-sm-6 text-end">
                                                    <button class="btn btn-primary" type="button" (click)="onSubmit()">
                                                        <span *ngIf="loading"
                                                            class="spinner-border spinner-border-sm me-2" role="status"
                                                            aria-hidden="true"></span>
                                                        {{loading ? 'Sending...' : 'Send Documnet'}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </cdk-step>
                        </ng-stepper>
                    </div>
                </div>
            </div>
        </div>
    </div>

    @if(isShowDoc){
    <div [hidden]="!isShowDoc">
        <app-pdf-signer [signData]="signData" (close)="close($event)">
        </app-pdf-signer>
    </div>
    }


    <div class="row g-3" [hidden]="!isUsedTemplateDoc">

        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="card h-100 shadow-sm">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex align-items-center justify-content-between">

                                <h5 class="card-title mb-0 fw-semibold">
                                    {{ selectedTemplate?.name }}
                                </h5>

                                <div class="d-flex align-items-center gap-2">
                                    <span class="badge bg-light text-dark border">
                                        {{ selectedTemplate?.category }}
                                    </span>

                                    <span class="badge bg-primary-subtle text-primary border">
                                        {{ allSignersPositions?.length || 0 }} Signer{{
                                        (allSignersPositions?.length || 0) > 1 ? 's' : '' }}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <p class="card-text text-muted mt-2">
                        {{ selectedTemplate?.description || '' }}
                    </p>

                    <form [formGroup]="documentForm" (ngSubmit)="submitTemplateDoc()">
                        <div class="row justify-content-center">
                            <div class="col-lg-10 col-md-8 col-sm-10">
                                <div class="mb-3">
                                    <label class="form-label" for="signing-order">
                                        Signing Order
                                    </label>
                                    <select class="form-select" id="signing-order" formControlName="signingOrder">
                                        <option value="sequential">Sequential (in Order )
                                        </option>
                                        <!-- <option value="parallel">Parallel (all sign at same
                                            time)</option> -->
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-center">
                            <div class="col-lg-10 col-md-8 col-sm-10">
                                <div class="mb-3">
                                    <label class="form-label" for="document-file">
                                        Upload Document <small class="text-danger">*</small>
                                    </label>

                                    <input type="file" class="form-control" id="document-file"
                                        (change)="onFileSelected($event)" accept="application/pdf">

                                    <div class="form-text">
                                        Allowed format: PDF. Maximum file size: 10 MB.
                                    </div>
                                    <div *ngIf="selectedFile" class="mt-1 text-muted small">
                                        Selected file: <strong>{{ selectedFile.name }}</strong>
                                    </div>
                                    <div *ngIf="fileError" class="text-danger small mt-1">
                                        {{ fileError }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-center">
                            <div class="col-lg-10 col-md-8 col-sm-10">
                                <div class="mb-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="livePhoto"
                                            formControlName="livePhoto" />
                                        <label class="form-check-label" for="livePhoto">
                                            Enable Live Photo
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div cdkDropList (cdkDropListDropped)="dropSigner($event)">

                            <div *ngFor="let recipient of signers.controls; let i = index" cdkDrag
                                class="row justify-content-center mb-2">
                                <div class="col-lg-10 col-md-8 col-sm-10">
                                    <div class="bg-light-purple p-3 rounded">
                                        <div class="row gx-2 align-items-center">
                                            <div class="col-1 d-flex justify-content-center">
                                                <div class="text-bold" cdkDragHandle title="Drag to reorder">
                                                    ☰ {{ i + 1 }}
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <input type="text" class="form-control" placeholder="Full Name"
                                                    [formControl]="recipient.get('name')"
                                                    (keypress)="allowRecipientNameCharacters($event)"
                                                    (input)="filterRecipientNameInput($event, recipient.get('name'))">
                                                <div class="text-danger small mt-1"
                                                    *ngIf="recipient.get('name')?.invalid && recipient.get('name')?.touched">

                                                    <span *ngIf="recipient.get('name')?.errors?.['required'] && recipient.get('name')?.value === ''">
                                                        Name is required
                                                    </span>
                                                    <span *ngIf="recipient.get('name')?.touched && recipient.get('name')?.value && recipient.get('name')?.value.trim() === ''">
                                                        Name cannot be empty or contain only spaces.
                                                    </span>
                                                    <span *ngIf="recipient.get('name')?.errors?.['pattern'] && recipient.get('name')?.value?.trim() !== ''">
                                                        Name can contain alphabets and spaces only.
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <input type="email" class="form-control" placeholder="Email"
                                                    [formControl]="recipient.get('email')">
                                                <div class="text-danger small mt-1"
                                                    *ngIf="recipient.get('email')?.touched && recipient.get('email')?.invalid">

                                                    <span *ngIf="recipient.get('email')?.errors?.['required']">
                                                        Email is required
                                                    </span>

                                                    <span *ngIf="recipient.get('email')?.errors?.['email']">
                                                        Enter a valid email address
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <input type="tel" maxlength="10" class="form-control"
                                                    placeholder="Phone" [formControl]="recipient.get('phone')"
                                                    inputmode="numeric" pattern="[0-9]*"
                                                    (keypress)="allowDigitsOnly($event)"
                                                    (input)="filterPhoneInput($event, recipient.get('phone'))">
                                                <div class="text-danger small mt-1"
                                                    *ngIf="recipient.get('phone')?.invalid && recipient.get('phone')?.touched">

                                                    <span *ngIf="recipient.get('phone')?.errors?.['required']">
                                                        Phone number is required
                                                    </span>

                                                    <span *ngIf="recipient.get('phone')?.errors?.['pattern']">
                                                        Enter a valid 10-digit number starting with 6-9
                                                    </span>

                                                </div>
                                            </div>
                                            <div class="col-2">
                                                <select class="form-select" [formControl]="recipient.get('esignType')">

                                                    <option value="" disabled>Select E-Sign Type
                                                    </option>
                                                    @for(type of esignTypes; track type;){
                                                    <option [value]="type?.value">
                                                        {{type?.label}}</option>
                                                    }
                                                </select>
                                            </div>
                                            <div class="col-1 d-flex justify-content-center">
                                                <!-- <button class="btn btn-light btn-sm" type="button"
                                                    [disabled]="signers.length === 1" (click)="removeRecipient(i)">
                                                    ×
                                                </button> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-center mt-3">
                            <div class="col-lg-10 col-md-8 col-sm-10">
                                <div class="row justify-content-center">
                                    <div class="col-lg-3 col-md-3 col-sm-3">
                                        <button class="btn btn-light w-100" type="button" (click)="back()">
                                            ← Back
                                        </button>
                                    </div>

                                    <div class="col-lg-9 col-md-9 col-sm-9">
                                        <button class="btn btn-primary w-100" type="button"
                                            (click)="submitTemplateDoc()">
                                            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"
                                                role="status" aria-hidden="true"></span>
                                            {{loading ? 'Sending...' : 'Send Documnet '}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>

    </div>
</div>